export default {
  methods: {
    toggle() {
      this.$emit('toggle', this.number);
    },
  },
  props: {
    /**
     * @description Отразить по горизонтали.
     * @type {boolean}
     */
    flip: Boolean,
    /**
     * @description Номер зуба.
     * @type {number}
     */
    number: Number,
    /**
     * @description Выбран.
     * @type {boolean}
     */
    selected: Boolean,
  },
};
